import { Link } from 'react-router-dom';
import { categories } from '@/mocks/dramas';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-300">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="inline-block mb-4">
              <span className="text-xl font-heading font-bold text-primary-500 tracking-wide">
                6080<span className="text-foreground-100">影视</span>
              </span>
            </Link>
            <p className="text-sm text-foreground-500 leading-relaxed">
              专注电视剧全集免费播放，高清不缓冲在线观看。涵盖最新热播剧、经典老剧、高分剧集，海量免费电视剧每日更新。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-foreground-200 mb-4">剧集分类</h3>
            <div className="flex flex-col gap-2">
              {categories.slice(0, 4).map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200 cursor-pointer"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-foreground-200 mb-4">更多分类</h3>
            <div className="flex flex-col gap-2">
              {categories.slice(4).map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200 cursor-pointer"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-foreground-200 mb-4">关于我们</h3>
            <div className="flex flex-col gap-2">
              <Link
                to="/about"
                className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200 cursor-pointer"
              >
                品牌介绍
              </Link>
              <Link
                to="/about"
                className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200 cursor-pointer"
              >
                联系我们
              </Link>
              <span className="text-sm text-foreground-600">contact@6080ys.com</span>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-300 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-600">
            &copy; 2024 6080影视. 本站内容仅供学习交流，请支持正版。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-foreground-500 hover:text-primary-500 transition-colors duration-200 cursor-pointer" aria-label="微博">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href="#" className="text-foreground-500 hover:text-primary-500 transition-colors duration-200 cursor-pointer" aria-label="微信">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a href="#" className="text-foreground-500 hover:text-primary-500 transition-colors duration-200 cursor-pointer" aria-label="QQ">
              <i className="ri-qq-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}